const visibleColumnsObjToList = visibleColumns => {
  if (visibleColumns) {
    return visibleColumns.map(entry => entry.value);
  }
  return undefined;
};

export const getSearchQuery = params => state => ({
  ...params,
  filters: params.filters ? params.filters : state.filter[params.entityType].filters,
  possibleFieldsList: state.filter[params.entityType].possibleFieldsList,
  page: params.page,
  visibleColumns: visibleColumnsObjToList(params.visibleColumns),
  visibleFields: visibleColumnsObjToList(params.visibleFields),
  elasticSearchFiltering: state.filter[params.entityType].elasticSearchFiltering
});

export const getFilters = params => state => ({
  ...params,
  filters: state.filter[params.entityType].filters,
  elasticSearchFiltering: state.filter[params.entityType].elasticSearchFiltering
});
